export const FullScreenIcon = `
<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="lucide lucide-expand">
    <path d="m21 21-6-6m6 6v-4.8m0 4.8h-4.8"/>
    <path d="M3 16.2V21m0 0h4.8M3 21l6-6"/>
    <path d="M21 7.8V3m0 0h-4.8M21 3l-6 6"/><path d="M3 7.8V3m0 0h4.8M3 3l6 6"/>
</svg>`

export const MinimizeIcon = `
<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="lucide lucide-minimize-2">
    <path d="M4 14 H10 V20 M20 10 H14 V4 M14 10 L21 3 M3 21 L10 14"/>
</svg>
`

export const ZoomOutIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zoom-out">
  <circle cx="11" cy="11" r="8"/>
  <path d="m21 21-4.35-4.35M8 11h6"/>
</svg>


`
